import React from "react"
import {withTheme, WithDefaultTheme} from "styled-components"

import IconButton from "@irati/ui/src/Button/IconButton"
import {IconTypes} from "@irati/ui/src/Icon"
import favouritesService from "@irati/deals/services/favourites"
import {Deal} from "@irati/types"
import IsDealFavourited from "@irati/deals/apollo/query/IsDealFavourited"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

export type FavouriteButtonOnChange = (isFavourite: boolean) => any

export interface FavouriteIconButtonProps extends WithDefaultTheme, WithPerkOrReward {
  deal: Deal,
  onChange?: FavouriteButtonOnChange,
  iconSize?: number,
  className?: string
}

const FavouriteButton: React.FC<FavouriteIconButtonProps> = ({deal, className, iconSize = 32, onChange, theme, isRewards}) => {
  if (isRewards) {
    return null
  }
  const onClick = (isFavourite: boolean, event: any) => {
    event.preventDefault()
    event.stopPropagation()

    if (onChange) {
      onChange(!isFavourite)
    }

    return isFavourite ? favouritesService.remove(deal) : favouritesService.add(deal)
  }

  return (
    <IsDealFavourited dealId={deal.uuid}>
      {({isFavourite}) => (
        <IconButton
          className={className}
          icon={isFavourite ? IconTypes.favouriteFill : IconTypes.favourite}
          size={iconSize}
          color={theme.colors.utility.white}
          onClick={(e: any) => onClick(isFavourite, e)} />
      )}
    </IsDealFavourited>
  )
}

export default withPerkOrReward(withTheme(FavouriteButton))
